//

import { ApiRequest } from "./base";

const apiRoute = "promos";

export const PromoApi = {
	async GenerateCouponCode(hash = false) {
		if (!hash) {
			console.error("PromoApi.js - No hash provided");
			return;
		}

		return await ApiRequest(`${apiRoute}/generate-coupon-code`, "POST", {
			hash: hash,
		});
	},

	async referAFriend(name, email) {
		const response = await ApiRequest(`${apiRoute}/refer-a-friend`, "POST", {
			name: name,
			email: email,
		});

		if (!response.message) return { message: "An error occurred", status: "fatal" };

		let status = "error";

		status = response.message.includes("already been referred") ? "warning" : status;
		status = response.message === "Your referral email has been sent." ? "success" : status;

		return {
			message: response.message,
			status: status,
		};
	},
};
